'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Create = require('./Create');

var _Update = require('./Update');

var _Remove = require('./Remove');

var _Bulk = require('./Bulk');

var _Perform = require('./Perform');

var _Fetch = require('./Fetch');

var _Instance = require('./Instance');

/**
 * Creates a new instance of each CRUD action
 * @param  {Object} config - action configuration
 *
 * @return {Object} - the set of CRUD action creators
 */
var actions = function actions(config) {

  if (!config) throw new Error('clerk.actions: Expected config');
  if (!config.actionPrefix) throw new Error('clerk.actions: Expected actionPrefix');
  if (!config.uidField) throw new Error('clerk.actions: Expected uidField');
  if (config.actionSettings) {
    if (!config.actionSettings.default.url) throw new Error('clerk.actions: Expected default url');
    if (!config.api) throw new Error('clerk.actions: Expected api middleware (axios)');
    if (!config.notificationActions) throw new Error('clerk.actions: Expected notification actions');
  }
  if (config.api) {
    if (!config.actionSettings) throw new Error('clerk.actions: Expected actionSettings object');
    if (!config.notificationActions) throw new Error('clerk.actions: Expected notification actions');
    if (!config.actionSettings.default.url) throw new Error('clerk.actions: Expected default url');
  }
  if (config.notificationActions) {
    if (!config.api) throw new Error('clerk.actions: Expected api middleware (axios)');
    if (!config.actionSettings) throw new Error('clerk.actions: Expected actionSettings object');
    if (!config.actionSettings.default.url) throw new Error('clerk.actions: Expected default url');
  }

  // Extend fetch options
  //config = Object.assign({}, this.defaultOptions, config)

  var fetchAction = new _Fetch.Fetch(config);
  var createAction = new _Create.Create(config);
  var updateAction = new _Update.Update(config);
  var removeAction = new _Remove.Remove(config);
  var bulkAction = new _Bulk.Bulk(config);
  var performAction = new _Perform.Perform(config);
  var instanceAction = new _Instance.Instance(config);

  return {
    fetch: fetchAction.do,
    create: createAction.do,
    update: updateAction.do,
    remove: removeAction.do,
    bulk: bulkAction.do,
    perform: performAction.do,
    createDataset: instanceAction.do
  };
};

exports.default = actions;